@if (isVisible()) {
  @if (isDocked()) {
    <button
      type="button"
      class="meeting-prep-tab"
      (click)="expand()"
      aria-label="Open Meeting Prep panel"
      ninetyTooltip="Meeting Prep">
      <terra-icon icon="caret-left" size="20" />
    </button>
  } @else if (!isExpanded()) {
    <div class="meeting-prep-bar">
      <div class="meeting-prep-bar__title-group">
        <span class="meeting-prep-bar__title">Meeting Prep</span>
        <ninety-chip color="brand" size="small">BETA</ninety-chip>
      </div>
      <div class="meeting-prep-bar__actions">
        <ninety-button
          flat
          icon
          class="meeting-prep-icon-btn"
          (click)="expand()"
          [ariaLabel]="'Open Meeting Prep panel'">
          <terra-icon icon="caret-up" size="20" />
        </ninety-button>
        <ninety-button
          flat
          icon
          class="meeting-prep-icon-btn"
          (click)="close('close_button')"
          [ariaLabel]="'Close Meeting Prep'"
          ninetyTooltip="You can reopen Meeting Prep from My Ninety">
          <terra-icon icon="x" size="20" />
        </ninety-button>
      </div>
    </div>
  } @else {
    <div class="meeting-prep-panel">
      <div class="meeting-prep-panel__header">
        <div class="meeting-prep-panel__header-top">
          <div class="meeting-prep-panel__meta">
            <terra-icon icon="meetings" size="24" variant="fill" class="meeting-prep-panel__meta-icon" />
            <p class="meeting-prep-panel__title">Meeting Prep</p>
            <ninety-chip color="brand" size="small">BETA</ninety-chip>
          </div>
          <div class="meeting-prep-panel__header-actions">
            <ninety-button
              flat
              icon
              class="meeting-prep-icon-btn"
              (click)="minimize()"
              [ariaLabel]="'Minimize Meeting Prep'">
              <terra-icon icon="caret-down" size="20" />
            </ninety-button>
            <ninety-button
              flat
              icon
              class="meeting-prep-icon-btn"
              (click)="close('close_button')"
              [ariaLabel]="'Close Meeting Prep'"
              ninetyTooltip="You can reopen Meeting Prep from My Ninety">
              <terra-icon icon="x" size="20" />
            </ninety-button>
          </div>
        </div>
      </div>

      <div class="meeting-prep-panel__body">
        <terra-form-field>
          <terra-form-label>Select a team to prepare for</terra-form-label>
          <terra-select
            [ngModel]="selectedTeamId()"
            (ngModelChange)="onTeamChange($event)"
            placeholder="Select a team"
            maxHeight="350">
            @for (team of teams(); track team._id) {
              <terra-option [value]="team._id">{{ team.name }}</terra-option>
            }
          </terra-select>
        </terra-form-field>

        <ul class="meeting-prep-cta-list" role="list">
          <li>
            <a
              class="meeting-prep-row"
              [routerLink]="selectedTeamId() ? routes.scorecard : null"
              [attr.aria-disabled]="!selectedTeamId() || null"
              [attr.tabindex]="!selectedTeamId() ? -1 : null"
              (click)="onItemClick('kpis', $event)">
              <div class="meeting-prep-row__left">
                <terra-icon icon="chart-bar" size="24" />
                <span class="meeting-prep-row__label">Scorecard</span>
              </div>
              <span class="meeting-prep-row__cta">Review scorecard</span>
            </a>
          </li>

          <li>
            <a
              class="meeting-prep-row"
              [routerLink]="selectedTeamId() ? routes.rocks : null"
              [attr.aria-disabled]="!selectedTeamId() || null"
              [attr.tabindex]="!selectedTeamId() ? -1 : null"
              (click)="onItemClick('rocks', $event)">
              <div class="meeting-prep-row__left">
                <terra-icon icon="rocks" size="24" />
                <span class="meeting-prep-row__label">Rocks</span>
              </div>
              <span class="meeting-prep-row__cta">Update progress</span>
            </a>
          </li>

          <li>
            <a
              class="meeting-prep-row"
              [routerLink]="selectedTeamId() ? routes.headlines : null"
              [attr.aria-disabled]="!selectedTeamId() || null"
              [attr.tabindex]="!selectedTeamId() ? -1 : null"
              (click)="onItemClick('headlines', $event)">
              <div class="meeting-prep-row__left">
                <terra-icon icon="headlines" size="24" />
                <span class="meeting-prep-row__label">Headlines</span>
              </div>
              <span class="meeting-prep-row__cta">Review headlines</span>
            </a>
          </li>

          <li>
            <a
              class="meeting-prep-row"
              [routerLink]="selectedTeamId() ? routes.todos : null"
              [attr.aria-disabled]="!selectedTeamId() || null"
              [attr.tabindex]="!selectedTeamId() ? -1 : null"
              (click)="onItemClick('todos', $event)">
              <div class="meeting-prep-row__left">
                <terra-icon icon="check-square" size="24" />
                <span class="meeting-prep-row__label">To-Dos</span>
              </div>
              <span class="meeting-prep-row__cta">Check Team To-Dos</span>
            </a>
          </li>

          <li>
            <a
              class="meeting-prep-row"
              [routerLink]="selectedTeamId() ? routes.issues : null"
              [attr.aria-disabled]="!selectedTeamId() || null"
              [attr.tabindex]="!selectedTeamId() ? -1 : null"
              (click)="onItemClick('issues', $event)">
              <div class="meeting-prep-row__left">
                <terra-icon icon="issues" size="24" />
                <span class="meeting-prep-row__label">Issues</span>
              </div>
              <span class="meeting-prep-row__cta">Review, create, prioritize</span>
            </a>
          </li>
        </ul>
      </div>

      <ninety-meeting-prep-feedback (rated)="onFeedbackRated($event)" (submitted)="onFeedbackSubmitted($event)" />
    </div>
  }
}
